<template>
  <div id="data-edit-tab-info">

    <!-- Content Row -->
    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" label="Name" v-model="data_local.name" v-validate="'required'" name="name" />
        <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>

        <div class="mt-4">
          <label class="vs-input--label">Classification</label>
          <v-select :options="optionClassification" :reduce="name => name.val" label="name" v-validate="'required'" v-model="data_local.classification" name="classification"/>
          <span class="text-danger text-sm"  v-show="errors.has('classification')">{{ errors.first('classification') }}</span> 
        </div>              

        <vs-textarea class="w-full mt-6" label="Notes" v-model="data_local.notes" name="notes" />
        <span class="text-danger text-sm"  v-show="errors.has('notes')">{{ errors.first('notes') }}</span> 

      </div>

      <div class="vx-col md:w-1/2 w-full">
        <div class="mt-4">
          <vs-input class="w-full mt-4" label="Email" v-model="data_local.email" type="email" v-validate="'required'" name="email" />
          <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
        </div>

        <div class="mt-4">
          <vs-input class="w-full mt-4" label="Phone" v-model="data_local.phone" type="phone" v-validate="'required'" name="phone" />
          <span class="text-danger text-sm"  v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
        </div>

        <div class="mt-4">
          <label class="vs-input--label">Address</label>
          <vue-google-autocomplete
            id="address"
            name="address"
            v-model="data_local.address"
            aria-describedby="address-feedback"
            class="vs-inputx vs-input--input normal w-full"
            style="border: 1px solid rgba(0, 0, 0, 0.2)"
            placeholder=""
            types=address
            ref=address    
            v-validate="'required'"
            v-on:placechanged="getAddressDataLine1"
          ></vue-google-autocomplete>

          <span class="text-danger">{{ errors.first('address') }}</span> 
        </div>

      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Save Changes</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import axios from '../../../../axios'
import VueGoogleAutocomplete from 'vue-google-autocomplete'

export default {
  components: {
    vSelect,
    VueGoogleAutocomplete
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      token: localStorage.usertoken,
      data_local: JSON.parse(JSON.stringify(this.data)),

      optionClassification: [
        { name: 'Hotel',  id: '1', val: 'Hotel' },
        { name: 'Union',  id: '2', val: 'Union' },
        { name: 'Property Management',  id: '3', val: 'Property Management' }
      ],

      statusOptions: [
        { label: 'Active',  value: 'active' },
        { label: 'Blocked',  value: 'blocked' },
        { label: 'Deactivated',  value: 'deactivated' }
      ],
      roleOptions: [
        { label: 'Admin',  value: 'admin' },
        { label: 'User',  value: 'user' },
        { label: 'Staff',  value: 'staff' }
      ]
    }
  },
  computed: {
    status_local: {
      get () {
        return { label: this.capitalize(this.data_local.status),  value: this.data_local.status  }
      },
      set (obj) {
        this.data_local.status = obj.value
      }
    },
    role_local: {
      get () {
        return { label: this.capitalize(this.data_local.role),  value: this.data_local.role  }
      },
      set (obj) {
        this.data_local.role = obj.value
      }
    },
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    getAddressDataLine1: function (addressData, placeResultData) {
      // console.log('getAddressDataLine1 ', addressData)
      const adStreet = typeof(addressData.street_number) === 'undefined' ? '' : addressData.street_number + ', '
      const adRoute = typeof(addressData.route) === 'undefined' ? '' : addressData.route + ' '
      const adAdmin1 = typeof(addressData.administrative_area_level_1) === 'undefined' ? '' : addressData.administrative_area_level_1 + ' '
      const adPostal = typeof(addressData.postal_code) === 'undefined' ? '' : addressData.postal_code + ' '
      
      this.data_local.address = adStreet + adRoute + addressData.locality + ' ' + adAdmin1 + adPostal + addressData.country
      // this.data_local.business_address_line_1 = adStreet + adRoute
      // this.data_local.business_city = addressData.locality
      // this.data_local.business_state = adAdmin1
      // this.data_local.business_zip = adPostal
      // this.data_local.business_country = addressData.country
    }, 
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */

      const editId = this.$route.params.editId
      new Promise(async(resolve, reject)  => {
        try {    
          await axios.post(`/portfolio/save/${editId}`, {
              data: this.data_local,
              token: this.token
            })
            .then(res => {
              if(res['data'] != 'access_denied' && res['data'] != '') {

                if(res['data'] == 'success') {
                  this.$vs.notify({
                    color: 'success',
                    title: 'Data Saved',
                    text: 'The selected data was successfully Saved'
                  })
                  this.$router.push({name:'app-portfolio-view', params: {viewId: editId }})
                } else {
                  this.$vs.notify({
                    color: 'danger',
                    title: 'Saving Data',
                    text: 'Something went wrong'
                  })
                }

              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
                this.$router.push({name:'app-portfolio-view', params: {viewId: editId }})
              }

            })
            .catch(err => {
              this.$vs.notify({
                color: 'danger',
                title: 'Data Saving Error',
                text: 'The selected data was not saved'
              })
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }      

      }) 
    },
    reset_data () {
      this.data_local = JSON.parse(JSON.stringify(this.data))
      this.$vs.notify({
        color: 'orange',
        title: 'Data Edit',
        text: 'The selected Data data was reset'
      })
    },
    update_avatar () {
      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB
    }
  }
}
</script>
